import '@babel/polyfill'

//import './publicpath'

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import '@/plugins/axios'
import '@/plugins/fontawesome'

import ClickOutside from 'vue-click-outside'

import ElementUI from 'element-ui'

// CARGAR STILO CUSTOM
//let location = window.location.host.split('.')
//let subdomain = location.length >= 3 ? location[0] : 'default' // Comprobar subdominio
import './assets/scss/variables.scss' // Cargar estilos en funcion del subdominio

import lang from 'element-ui/lib/locale/lang/es'
import locale from 'element-ui/lib/locale'

import referencias from './plugins/referencias'
import Porlet from './components/Porlet.vue'

import * as VueWindow from '@hscmap/vue-window'
import VueWindowSize from 'vue-window-size';

import VueMq from 'vue-mq'

import store from './store'
import * as api from './helpers/api'

import './registerServiceWorker'

import VueMasonry from 'vue-masonry-css'

import VueCookies from 'vue-cookies'
import VueMeta from 'vue-meta'

Vue.use(VueMeta)
Vue.use(VueCookies)

Vue.use(VueMasonry);

Vue.use(VueMq, {
  breakpoints: {
    xs: 768,
    sm: 992,
    md: 1200,
    lg: 1920,
    xl: Infinity
  }
})

Vue.use(VueWindow)
 
Vue.use(VueWindowSize, {
  delay: 100,
});

Vue.component('Porlet',Porlet)

Vue.use(referencias)

Vue.use(ElementUI);

locale.use(lang)

Vue.config.productionTip = true // process.env.NODE_ENV !== 'development'

Vue.config.devtools = true //process.env.NODE_ENV === 'development'

Vue.directive('click-outside',ClickOutside)

const setup = async () => {

  await api.init()

  window.api = api

  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
  
}

setup()